import { useEffect, useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { firmDocumentsUrl } from 'common/config/urls';
import { useGuidedTour } from 'components/ui';
import { getFirmDocumentsTour } from 'pages/Documents/FirmDocuments/tours';
import { workspaceNavigationTour } from './workspaceNavigationTour';

const FirmBaseLayoutProductTours = () => {
  const location = useLocation();
  const { firmSlugParam } = useParams<{ firmSlugParam: string }>();
  const { registerTours } = useGuidedTour();
  const hasFirmContext = Boolean(firmSlugParam && firmSlugParam !== '0');
  const firmDocumentsPath = hasFirmContext && firmSlugParam ? firmDocumentsUrl(firmSlugParam) : '';
  const isFirmDocumentsRoute =
    Boolean(firmDocumentsPath) &&
    (location.pathname === firmDocumentsPath || location.pathname.startsWith(`${firmDocumentsPath}/`));
  const tours = useMemo(() => {
    if (!hasFirmContext) {
      return [];
    }

    return [
      { definition: workspaceNavigationTour },
      { definition: getFirmDocumentsTour(firmSlugParam), isRecommended: isFirmDocumentsRoute },
    ];
  }, [firmSlugParam, hasFirmContext, isFirmDocumentsRoute]);

  // Shell tours depend on selectors and destinations that only exist with a real firm context.
  useEffect(() => registerTours(tours), [registerTours, tours]);

  return null;
};

export default FirmBaseLayoutProductTours;
